import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/AdminShell";
import { AdminMarketMemory } from "@/components/AdminMarketMemory";

export const Route = createFileRoute("/_authenticated/admin/marknadsminne")({
  head: () => ({
    meta: [
      { title: "Marknadsminne — Administration" },
      {
        name: "description",
        content:
          "Internt: sparade marknadssökningar och prisfynd som återanvänds i värderingar och prisgranskning.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Marknadsminne — Administration" },
      {
        property: "og:description",
        content: "Sparade marknadssökningar och prisfynd som gör värderingarna snabbare och billigare.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <AdminShell title="Marknadsminne">
      <AdminMarketMemory />
    </AdminShell>
  ),
});
